import React from 'react';
import { useResponsive } from './UseResponsive';
export const ResponsiveContext = React.createContext(null);
export const useResponsiveContext = () => React.useContext(ResponsiveContext);
export const ResponsiveProvider = ({ children }) => {
    const useResponsiveMethods = useResponsive();
    return (React.createElement(ResponsiveContext.Provider, { value: useResponsiveMethods }, children));
};
ResponsiveProvider.displayName = 'ResponsiveProvider';
